// ====== Intro "porta + fantasma" su click slide ======
(function(){
  const DURATION = 950; // ms prima della navigazione (sincronizzata all'animazione)

  function ensureOverlay(){
    let ov = document.getElementById('intro-door-overlay');
    if(!ov){
      ov = document.createElement('div');
      ov.id = 'intro-door-overlay';
      ov.innerHTML = `
        <div class="backdrop"></div>
        <div class="stage">
          <div class="door left"></div>
          <div class="door right"></div>
          <div class="ghost"></div>
        </div>`;
      document.body.appendChild(ov);
    }
    return ov;
  }

  function playAndGo(url){
    const ov = ensureOverlay();
    ov.classList.add('active');
    // attiva overlay
    ov.style.display = 'block';
    // vai alla collezione dopo l'animazione
    setTimeout(()=>{ window.location.href = url; }, DURATION);
  }

  function clickHandler(e){
    const a = e.target.closest('a');
    if(!a) return;
    // Intercettiamo solo i link dentro slideshow/banner
    const inSlide = a.closest('.slideshow, .slideshow__slide, .banner, .banner__media, .image-banner');
    if(!inSlide) return;

    // Solo link a collezioni (se vuoi tutti, rimuovi il check):
    const href = a.getAttribute('href') || '';
    if(!href || !/\/collections\//.test(href)) return;

    // stop default → gioca intro → naviga
    e.preventDefault();
    playAndGo(a.href);
  }

  function init(){
    document.addEventListener('click', clickHandler, { passive:false });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
